//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import productPreviewModeMixin from '@motionelements/product2025/src/mixins/product-preview-mode.mixin.js';
import { getMediaTypeGroup } from '@motionelements/core/src/services/catalog.service.js';
import { faMeSubscription } from '@motionelements/assets/src/js/me-font/icons-channels2022';
import { filterObj } from '@/helpers/object.js';

export default {
  name: 'ProductCtaBlock',
  components: {
    SubscriptionButton: () => import('@motionelements/product2025/src/components/buttons/SubscriptionButton.vue'),
    CtaButtons: () => import('@motionelements/product2025/src/sections/CtaButtons.vue'),
    ProductPrice: () => import('@motionelements/product2025/src/components/ProductPrice.vue'),
    FlagProduct: () => import('@motionelements/catalog/src/modules/product/element/FlagProduct.vue'),
    FeaturedIcons: () => import('@motionelements/product2025/src/sections/FeaturedIcons.vue'),
    Relationships: () => import('@motionelements/product2025/src/sections/Relationships.vue'),
  },
  mixins: [featureFlagMixin, productPreviewModeMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      faMeSubscription,
      faInfoCircle,
      keys: ['format', 'price', 'downloadable', 'free', 'subscription', 'loading'],
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
      loading: state => state.product.loading,
      archiveEntries: state => state.product.archiveEntries,
    }),
    ...mapGetters({
      hasUnlimitedSubscription: 'user/hasUnlimitedSubscription',
      masterVariant: 'product/masterVariant',
      isFree: 'product/isFree',
      isDownloadableDirectly: 'product/isDownloadableDirectly',
      archiveEntriesExtensions: 'product/archiveEntriesExtensions',
      isExclusive: 'product/isExclusive',
      isEditorialUseOnly: 'product/isEditorialUseOnly',
      mediaType: 'product/mediaType',
      hasStem: 'product/hasStem',
      fullPath: 'route/fullPath',
      isMobile: 'browser/isMobile',
      relatedElements: 'product/relatedElements',
      //
      languageCode: 'user/languageCode',
      currencyCode: 'user/currencyCode',
    }),
    showSubscription() {
      return this.product.subscription && !this.hasUnlimitedSubscription;
    },
    features() {
      let array = [];
      if (this.isExclusive) array.push('exclusive');
      if (this.mediaType === 'music') {
        array = [...array, 'pro', 'loopable'];
        if (this.hasStem) array.push('stem');
      }
      if (getMediaTypeGroup(this.mediaType) === 'video') {
        if (this.isEditorialUseOnly) {
          array.push('editorial_use_only');
        }
        // Upscale feature for video only if user has subscription and has 4k format in variants
        if (this.hasUnlimitedSubscription && this.videoFormats.includes('4k')) {
          array.push('upscale');
        }
      }
      if (getMediaTypeGroup(this.mediaType) === 'image') {
        if (this.isEditorialUseOnly) {
          array.push('editorial_use_only');
        }
      }
      return array;
    },
    videoFormats() {
      return this.product.variants.map(({ format }) => format);
    },
    variantFormatLabels() {
      return this.product.variants
        .map(({ format, width, height }) => ({
          format: format.toUpperCase(),
          ...(width && height && { resolution: `${width}x${height}` }),
        }));
    },
    //
    relationType() {
      switch (this.product?.mediaType) {
        case 'photo':
        case 'vector':
        case 'gif':
        case 'photo_vr':
        case 'video':
        case 'video_live':
        case 'animation':
        case 'video_vr':
          return 'related_elements';
        case 'ae_template':
        case 'pr_template':
        case 'motion_template':
        case 'mg_template':
          return 'recommended_music';
        default:
          return null;
      }
    },
    showUpscaleHint() {
      return (format) => format === '4K' && this.features.includes('upscale');
    },
  },
  mounted() {
    this.fetchProduct({
      id: this.product.id,
      relationType: this.relationType,
    })
      .then(() => {
        this.$store.commit('product/setLoading', false);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  methods: {
    ...mapActions({
      fetchProduct: 'product/fetchProduct',
    }),
    filterObj,
    showFlagProductModal() {
      if (!this.isProductPreviewMode) this.$bvModal.show('flag-product-modal');
    },
  },
};
